if (!customElements.get('slider-navigation')) {
  document.addEventListener('shopify:block:select', function (event) {
    event.target.closest('slider-component')?.focusSlide(event.target, 0, 'instant', true);
    event.target.closest('slider-navigation')?.stopAutoplay();
  });
  customElements.define(
    'slider-navigation',
    class SliderNavigation extends HTMLElement {
      constructor() {
        super();
        this.tabs = this.querySelector('slider-component.navigation-tabs');
        this.highlight = this.tabs.querySelector('focus-highlight');
        this.containers = this.querySelector('slider-component.navigation-containers');
        this.containers.slider.addEventListener('scroll', this.update.bind(this), { passive: true });

        this.tabs.sliderItems.forEach(
          function (tab, index) {
            tab.addEventListener(
              'click',
              function () {
                this.focusSlide(index);
              }.bind(this),
            );
            tab.addEventListener(
              'keydown',
              function (event) {
                if (event.keyCode === 13) {
                  this.focusSlide(index);
                }
              }.bind(this),
            );
          }.bind(this),
        );

        const tabUrlParam = this.dataset.tabUrlParam;
        const urlParams = new URLSearchParams(window.location.search);
        if (tabUrlParam && tabUrlParam.length > 0 && urlParams.has(tabUrlParam)) {
          this.selectTab(parseInt(urlParams.get(tabUrlParam)));
        } else {
          this.selectTab(0);
        }

        this.setupAutoplay();
      }

      focusSlide(index) {
        this.containers.sliderItems.forEach(item => item.removeAttribute('aria-selected'));
        this.containers.focusSlide(this.containers.sliderItems[index]);
        this.containers.sliderItems[index].setAttribute('aria-selected', 'true');
      }

      setupAutoplay() {
        this.speed = parseFloat(this.dataset.speed);
        this.shouldPlay = !isNaN(this.speed) && this.speed > 0;
        if (this.shouldPlay) {
          var dragStartSlide = undefined;
          this.querySelectorAll('slider-component.navigation-tabs label, slider-component.navigation-containers .slider-button').forEach(
            tab =>
              tab.addEventListener('click', () => {
                dragStartSlide = undefined;
                this.stopAutoplay();
              }),
          );
          this.addEventListener(
            'touchstart',
            () => {
              dragStartSlide = this.currentSlidePath().at(-1);
              this.stopAutoplay();
            },
            { passive: true },
          );
          this.addEventListener(
            'touchend',
            () => {
              setTimeout(() => {
                if (this.currentSlidePath().at(-1) == dragStartSlide) this.startAutoplay();
              }, 1000);
            },
            { passive: true },
          );

          var inView = false;
          const onScroll = () => {
            const rect = this.getBoundingClientRect();
            const center = (rect.top + rect.bottom) * 0.5;
            const inViewNow = center >= 0 && center <= (window.innerHeight || document.documentElement.clientHeight);
            if (inView != inViewNow) {
              if (inViewNow) {
                this.startAutoplay();
              } else {
                this.stopAutoplay();
              }
              inView = inViewNow;
            }
          };
          onScroll();
          document.addEventListener('scroll', onScroll.bind(this), { passive: true });
        }
      }

      startAutoplay() {
        if (!this.process) {
          this.process = setInterval(this.nextSlide.bind(this), this.speed * 1000);
        }
      }

      stopAutoplay() {
        if (this.process) {
          clearInterval(this.process);
          delete this.process;
        }
      }

      currentSlidePath() {
        var descendant = this;
        var path = [];
        do {
          descendant = descendant?.containers?.sliderItems[descendant?.selectedIndex];
          if (descendant) {
            path.push(descendant);
          }
          // descendant = descendant.querySelector('slider-navigation');
        } while (descendant);
        return path;
      }

      nextSlide() {
        var descendant = this;
        var path = this.currentSlidePath();

        do {
          var next = path.pop().nextElementSibling;
        } while (!next && path.length > 0);

        descendant = next ? next : this;
        do {
          descendant = descendant.querySelector('slider-component.navigation-containers');
          descendant = descendant?.sliderItems[0];
          if (descendant) next = descendant;
        } while (descendant);

        next.closest('slider-component')?.focusSlide(next, 0, 'auto', true);
      }

      selectTab(selectIndex, assert = true) {
        if (isNaN(selectIndex)) selectIndex = 0;
        if (assert) {
          this.containers.focusSlide(this.containers.sliderItems[selectIndex]);
        }

        this.tabs.sliderItems.forEach((tab, index) => {
          if (index == selectIndex) {
            this.tabs.focusSlide(tab);
            if (this.highlight != undefined && typeof this.highlight.setTarget == 'function') this.highlight.setTarget(tab);
            tab.classList.add('active');
          } else {
            tab.classList.remove('active');
          }
        });
        this.selectedIndex = selectIndex;
        var highest = this;
        while (true) {
          const next = highest.parentElement.closest('slider-navigation');
          if (next) highest = next;
          else break;
        }
        highest.adjustHeight();
      }

      adjustHeight() {
        const nav = this.containers;
        const child = this.currentSlidePath().at(-1);
        const navRect = nav.getBoundingClientRect();
        const childRect = child.getBoundingClientRect();
        const bottomPadding = window.getComputedStyle(nav, null).getPropertyValue('padding-bottom');
        const height = 'calc(' + (childRect.height + childRect.y - navRect.y) + 'px + ' + bottomPadding + ')';
        // console.log(height);
        nav.style.height = height;
        // const slides = this.containers.sliderItems;
        // var nav = this.closest('slider-component.navigation-containers');// ?? this.containers
        // if(nav && slides.length >= 2) {
        //   const slider = this.containers.slider;
        //   const sliderCenter = slider.scrollLeft + slider.clientWidth * 0.5;

        //   var transitionIndex = 0;
        //   var transitionOffset = 0;
        //   for(const slide of slides) {
        //     const slideWidth = slide.clientWidth;
        //     if(transitionIndex == 0 || transitionOffset + slideWidth * 0.5 < sliderCenter) {
        //       transitionIndex++;
        //       transitionOffset += slideWidth;
        //     } else {
        //       break;
        //     }
        //   }
        //   transitionIndex = Math.max(1, Math.min(transitionIndex, slides.length - 1));
        //   const fromSlide = slides[transitionIndex - 1];
        //   const toSlide = slides[transitionIndex];
        //   const fromX = transitionOffset - fromSlide.clientWidth * 0.5;
        //   const toX = transitionOffset + toSlide.clientWidth * 0.5;
        //   const fromY = fromSlide.clientHeight;
        //   const toY = toSlide.clientHeight;

        //   const t = Math.min(1.0, Math.max(0.0, (sliderCenter - fromX) / (toX - fromX)));
        //   // console.log((sliderCenter - fromX) / (toX - fromX))
        //   const y = fromY + (toY - fromY) * t;
        //   // console.log(t, y);
        //   nav.style.height = y + 150 + 'px';
        // }
      }

      update() {
        if (this.selectedIndex != this.containers.currentPage - 1) {
          this.selectTab(this.containers.currentPage - 1, false);
        }
      }
    },
  );
}
